import React from "react";
import classNames from "classnames";

type Size = "small" | "medium" | "large";

type SpinnerProps = React.PropsWithChildren<{
  centered?: boolean;
  size?: Size;
  inline?: boolean;
}>;

type WrapperBlockProps = React.PropsWithChildren<{}>;

export function WrapperBlock({ children, ...rest }: WrapperBlockProps) {
  return <div {...rest}>{children}</div>;
}

export function SVVSpinner({
  centered = true,
  size = "medium",
  inline = false,
  children,
}: SpinnerProps) {
  const SpinnerWrapper: any = inline ? React.Fragment : WrapperBlock;

  return (
    <SpinnerWrapper
      className={classNames({
        "svv-spinner--centered": centered,
      })}
    >
      <div
        className={classNames("svv-spinner__wrapper svv-spinner--active", {
          "svv-spinner--small": size === "small",
          "svv-spinner--large": size === "large",
        })}
      >
        <div className="svv-spinner__layer">
          <div className="svv-spinner__circle-clipper svv-spinner__circle-clipper--left">
            <div className="svv-spinner__circle" />
          </div>
          <div className="svv-spinner__spacing-fix">
            <div className="svv-spinner__circle" />
          </div>
          <div className="svv-spinner__circle-clipper svv-spinner__circle-clipper--right">
            <div className="svv-spinner__circle" />
          </div>
        </div>
      </div>
      {children && <div className="svv-spinner__text">{children}</div>}
    </SpinnerWrapper>
  );
}

SVVSpinner.displayName = "SVVSpinner";
